import {createPreloadableLazyComponent} from '../../util/lazyImport';
import type {RouteData} from '../types';
import {ARIA_PATH} from './ariaPaths';

export const ARIA_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'ARIA',
    },
    exact: true,
    isPrivateRoute: true,
    path: ARIA_PATH,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/AriaPage')
    ).Component,
  },
];
